export const hasBankSlipToggle = (search: string) => {
    const params = new URLSearchParams(search)
    return params.has('boleto')
}
